import { createContext, useContext, useEffect, useState } from 'react';
import { getCurrentLifeEvent, getFingertipsLinks } from '../services/dashboard';
import {
  getActiveHealthBenefits,
  getActiveLifeAndDisabilityInsurances,
  getActiveSpendingAccounts,
  getActiveLifestyleBenefits,
} from '../services/enrollment';
import { AuthStore } from './auth';

export type LifeEventsState = {
  activeHealthBenefits: Array<any>;
  activeSpendingAccounts: Array<any>;
  activeLifeAndDisabilityInsurances: Array<any>;
  activeLifestyleBenefits: Array<any>;
  fingertipLinks: Array<any>;
  currentLifeEvent: any;
  currentPersona?: any;
};

export const LifeEventsStore = createContext<LifeEventsState>({
  activeHealthBenefits: [],
  activeSpendingAccounts: [],
  activeLifeAndDisabilityInsurances: [],
  activeLifestyleBenefits: [],
  fingertipLinks: [],
  currentLifeEvent: undefined,
  currentPersona: '',
});

const { Provider } = LifeEventsStore;

export const LifeEventsProvider = ({ children }: any) => {
  const [, , , selectedPersona] = useContext(AuthStore) || [];
  const [lifeEventsState, setLifeEventsState] =
    useState<LifeEventsState>({
      activeHealthBenefits: [],
      activeSpendingAccounts: [],
      activeLifeAndDisabilityInsurances: [],
      activeLifestyleBenefits: [],
      fingertipLinks: [],
      currentLifeEvent: {},
      currentPersona: '',
    });

  useEffect(() => {
    let activeHealthBenefits = getActiveHealthBenefits();
    let activeSpendingAccounts = getActiveSpendingAccounts();
    let activeLifeAndDisabilityInsurances =
      getActiveLifeAndDisabilityInsurances();
    let activeLifestyleBenefits = getActiveLifestyleBenefits();
    let fingertipLinks = getFingertipsLinks(selectedPersona);
    let currentLifeEvent = getCurrentLifeEvent();

    setLifeEventsState({
      activeHealthBenefits,
      activeSpendingAccounts,
      activeLifeAndDisabilityInsurances,
      activeLifestyleBenefits,
      currentLifeEvent,
      fingertipLinks,
      currentPersona: selectedPersona,
    });
  }, [selectedPersona]);

  return <Provider value={lifeEventsState}>{children}</Provider>;
};
